import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AppScopes } from 'app/core/authentication/models/scopes.enum';
import { AuthService } from 'app/core/authentication/services';
import { UserInterface } from 'app/core/user/models';
import { UserProfileDialogComponent } from 'app/shared/components/user-profile-dialog/user-profile-dialog.component';
import { TaskDialogDataInterface } from 'app/task/models/task-dialog-data.model';
import { TaskDialogService } from 'app/task/services/task-dialog.service';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'cz-create-task-button',
  templateUrl: './create-task-button.component.html',
  styleUrls: ['./create-task-button.component.scss'],
})
export class CreateTaskButtonComponent implements OnInit, OnDestroy {
  public loggedInUser: UserInterface;
  public isTaskAdmin: boolean;

  private destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(public readonly dialog: MatDialog,
              private readonly _taskDialogService: TaskDialogService,
              private readonly _authService: AuthService) { }

  public ngOnInit(): void {
    this._authService.isLoggedInUserAuthorized([AppScopes.CASE_MANAGEMENT_MASTER]).pipe(
      take(1))
      .subscribe((isTaskAdmin: boolean) => {
        this.isTaskAdmin = isTaskAdmin;
      });
    this._authService.getLoggedInUser()
    .pipe(take(1))
    .subscribe((user: UserInterface) => {
      this.loggedInUser = user;
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public openNewTaskDialog(): void {
    if(!this.loggedInUser || this.loggedInUser.id < 1) { return; }

    const dialogData: TaskDialogDataInterface = {
      loggedInUser: this.loggedInUser,
      assignedTo: this.loggedInUser,
      isTaskAdmin: this.isTaskAdmin,
    };

    this._taskDialogService.createNewTaskDialog(dialogData);
  }

  public createNewUser(): void {
    this.dialog.open(UserProfileDialogComponent, {
      height: '900px',
      width: '800px',
      panelClass: 'user-profile-dialog',
      data: undefined,
    });
  }
}
